import $ from 'jquery';
import Sloth from './Sloth';
import './main';
window.Sloth = Sloth

$(() => {
    setTimeout(() => {
        Sloth.init();
    });
});

export default Sloth;



/** WEBPACK FOOTER **
 ** ./components/index.js
 **/